export default "__VITE_ASSET__AYtgxeEt__"